import api, { handleResponse, handleError } from './api';

/** The one-prompt planner: plans, revisions, approve/book, and planner billing. */
const wrap = async (call) => {
  try { return handleResponse(await call()); } catch (error) { return handleError(error); }
};

const plannerService = {
  create: (payload) => wrap(() => api.post('/plans', payload)),
  mine: () => wrap(() => api.get('/plans')),
  get: (id) => wrap(() => api.get(`/plans/${id}`)),
  revise: (id, note) => wrap(() => api.post(`/plans/${id}/revise`, { note })),
  approve: (id) => wrap(() => api.post(`/plans/${id}/approve`)),
  // The host may have reworded the prompt in the box; send it with the draw so a failed
  // attempt still keeps what they typed.
  regeneratePoster: (id, prompt) => wrap(() => api.post(`/plans/${id}/poster`, { prompt: prompt ?? null })),
  setPosterPrompt: (id, prompt) => wrap(() => api.put(`/plans/${id}/poster/prompt`, { prompt: prompt ?? null })),
  setPosterReference: (id, file) => {
    const form = new FormData();
    form.append('file', file);
    return wrap(() => api.post(`/plans/${id}/poster/reference`, form, { headers: { 'Content-Type': 'multipart/form-data' } }));
  },
  clearPosterReference: (id) => wrap(() => api.delete(`/plans/${id}/poster/reference`)),
  // WHAT SHOULD IT HANDLE? — { sound, staff, permits, numbers, poster }: true = leave it out.
  setSkip: (id, skip) => wrap(() => api.put(`/plans/${id}/skip`, skip)),
  cancelApproval: (id) => wrap(() => api.post(`/plans/${id}/cancel-approval`)),
  revertTo: (id, version) => wrap(() => api.post(`/plans/${id}/revert/${version}`)),
  // Who BOOK IT would contact, so it can be confirmed first. Reading this sends nothing.
  bookPreview: (id) => wrap(() => api.get(`/plans/${id}/book/preview`)),
  book: (id) => wrap(() => api.post(`/plans/${id}/book`)),
  choose: (id, payload) => wrap(() => api.post(`/plans/${id}/choose`, payload)),
  setPermit: (id, name, status) => wrap(() => api.post(`/plans/${id}/permits`, { name, status })),
  archive: (id) => wrap(() => api.post(`/plans/${id}/archive`)),
  billing: () => wrap(() => api.get('/plans/billing')),
  startBilling: (payload) => wrap(() => api.post('/plans/billing/start', payload)),
  cancelBilling: () => wrap(() => api.post('/plans/billing/cancel')),
};

export default plannerService;
